export const defaultModes = ['gitlab', 'github', 'bitbucket']
export const defaultIdPrefix = 'site-mode-'
